import React from 'react';
import cssmodules from 'react-css-modules';
import CreateIdeaButton from '../Shared/CreateIdeaButton'
import {Panel, FormControl, Button} from 'react-bootstrap';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import { Link } from 'react-router';

class IdeaBox extends React.Component {
  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const { count } = this.props;
    const {browseTitle} = this.props;
    const {browseUrl} = this.props;
    return (
       <Panel className="brand-panel">
                  <div className="row">
                    <div className="col-md-4">
                      <Panel style={{textAlign : 'center',backgroundColor : '#DCDCDC'}}>
                          <h1 style={{fontWeight:700}}>{count}</h1>
                          <p>{this.props.unit}<br/>{t('YEAR') + ' ' + new Date().getFullYear()}</p>
                        </Panel>
                    </div>
                    <div className="col-md-8">
                        <p>{this.props.description}</p>
                        <p><Link to={browseUrl} className="btn-brand btn btn-default btn-sm">{browseTitle}</Link></p>
                    </div>
                  </div>
                <CreateIdeaButton to={this.props.to} title={this.props.buttonTitle} icon={this.props.buttonIcon} ></CreateIdeaButton>
      </Panel>
    );
  }
}

IdeaBox.displayName = 'IdeaBox';
IdeaBox.propTypes = {};
IdeaBox.defaultProps = {};

export default injectIntl(IdeaBox);



// WEBPACK FOOTER //
// ./components/Home/IdeaBox.js